import { createReducer } from "@reduxjs/toolkit";
import {
  GetEmailHistoryList, getEamilHistoryListSuccess,
  getSupplierEmailHistoryListSuccess,
  loadingList,
  loadingSupplierList
} from "./emailHistoryAction";
import { get } from "http";
export interface IEmailHistoryState {
  emailHistoryList?: Array<any>;
  dataCount: number;
  isLoading?: boolean;
  supplierEmailHistoryList?: Array<any>;
  isSupplierEmailLoading?: boolean;
  supplierDataCount?: number;
}
const initialState: IEmailHistoryState = {
  emailHistoryList: [],
  dataCount: 0,
  isLoading: false,
  supplierEmailHistoryList: [],
  isSupplierEmailLoading: false,
  supplierDataCount: 0,
};
export const EmailHistoryReducer = createReducer(initialState, (builder) => {
  builder

    .addCase(getEamilHistoryListSuccess, (state, action) => {
      state = {
        ...state,
        emailHistoryList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(loadingList, (state, action) => {
      state.isLoading = action.payload;
    })
     .addCase(loadingSupplierList, (state, action) => {
      state.isSupplierEmailLoading = action.payload;
    })
    .addCase(getSupplierEmailHistoryListSuccess, (state, action) => {
      state = {
        ...state,
        supplierEmailHistoryList: action.payload?.data,
        supplierDataCount: action.payload?.dataCount,
      };
      return state;
    })
});
